export const CC_PATH = 'api/ccapi'

export enum EndPoints {
    GetStudentInfo = 'GetStudentInfo',
    GetLMSData = 'GetLMSData',
    SetLMSData = 'SetLMSData',
    ConcedeControl = 'ConcedeControl',
}